// https://nanoid.yuuniworks.com/ - 8 length, no symbols

export const navigationIDs = {
    logo: {
        id: '3VHana6Q',
        component: 'header',
        location: 'logo',
        description: 'On click logo',
    },
    toggleMenu: {
        id: 'aOFarAUW',
        component: 'header',
        location: 'toggleMenu',
        description: 'On Opening the toggle menu',
    },
    education: {
        id: 'vemb7fZN',
        component: 'header',
        location: 'educationLink',
        description: 'On click education link',
    },
    organizers: {
        id: '1L6SldoE',
        component: 'header',
        location: 'organizersLink',
        description: 'On click organizers and coaches link',
    },
    signIn: {
        id: 'Wv2eoIYL',
        component: 'header',
        location: 'signInLink',
        description: 'On click signIn link',
    },
    join: {
        id: 'P3HoXptN',
        component: 'header',
        location: 'joinLink',
        description: 'On click join link',
    },
    home: {
        id: 'HbvIBkiv',
        component: 'header',
        location: 'homeLink',
        description: 'On click home link',
    },
    explore: {
        id: 'dFcFWbEa',
        component: 'header',
        location: 'exploreLink',
        description: 'On click explore link',
    },
    messages: {
        id: 'KQ01gF6u',
        component: 'header',
        location: 'messagesLink',
        description: 'On click messages link',
    },
    players: {
        id: 'HJHZ9gH4',
        component: 'header',
        location: 'playersLink',
        description: 'On click players link',
    },
    events: {
        id: 'WOL7RdGN',
        component: 'header',
        location: 'eventsLink',
        description: 'On click events link',
    },
    collegeCorner: {
        id: 'lAPdBZC9',
        component: 'header',
        location: 'collegeCornerLink',
        description: 'On click college corner link',
    },
    toggleMenuAuth: {
        id: 'YRKMWPEu',
        component: 'header',
        location: 'toggleMenuAuth',
        description: 'On toggle menu, authenticated user',
    },
    power: {
        id: 'f0HrSz2q',
        component: 'header',
        location: 'powerPerksLink',
        description: 'On click power link',
    },
    startPower: {
        id: 'C5n78TFo',
        component: 'header',
        location: 'powerPerksLink',
        description: 'On click start power link',
    },
    postScore: {
        id: 'VliwOxDX',
        component: 'header',
        location: 'postScoreHeaderMenu',
        description: 'On click post score header menu component',
    },
    mobileHome: {
        id: 'BJe5lvPl',
        component: 'header',
        location: 'mobileHomeLink',
        description: 'On click mobile Home link',
    },
    mobileExplore: {
        id: 'b1Shusa0',
        component: 'header',
        location: 'mobileExploreLink',
        description: 'On click mobile Explore link',
    },
    mobilePlayers: {
        id: 'ErXRutIo',
        component: 'header',
        location: 'mobilePlayersLink',
        description: 'On click mobile Players link',
    },
    mobileEvents: {
        id: 'PKoxZVET',
        component: 'header',
        location: 'mobileEventsLink',
        description: 'On click mobile Events link',
    },
    postScoreMobile: {
        id: '16aXF7i7',
        component: 'header',
        location: 'postScoreMobileHeaderMenu',
        description: 'On click mobile post ccore mobile header menu',
    },
    messagesMobile: {
        id: 'HY7OycDr',
        component: 'header',
        location: 'messagesMobileLink',
        description: 'On click mobile messages link',
    },
    menu: {
        id: 'PReGFo0q',
        component: 'header',
        location: 'menuLink',
        description: 'On click mobile menu link',
    },
    closeIcon: {
        id: '7ii96zbW',
        component: 'header',
        location: 'closeIconButton',
        description: 'On click close button',
    },
};

export const headerMenuIDs = {
    createPlay: {
        id: 'oOtkam2H',
        component: 'headerMenu',
        location: 'createPlayLink',
        description: 'On click create play link',
    },
    offer: {
        id: 'GDSzcoJh',
        component: 'headerMenu',
        location: 'offerPaidHitsLink',
        description: 'On click offer link',
    },
    createPaidHit: {
        id: 'oOtkam2H',
        component: 'headerMenu',
        location: 'createPaidHitLink',
        description: 'On click create Paid Hit link',
    },
    postScore: {
        id: 'C8YNR945',
        component: 'headerMenu',
        location: 'postScoreLink',
        description: 'On click post Score link',
    },
    createEvent: {
        id: 'WSukBf3I',
        component: 'headerMenu',
        location: 'createEventLink',
        description: 'On click create event link',
    },
};

export const globalSearchIDs = {
    players: {
        id: 'sti6lQMv',
        component: 'globalSearch',
        location: 'playersButton',
        description: 'On click players button',
    },
    events: {
        id: 'HAWFW5cz',
        component: 'globalSearch',
        location: 'eventsButton',
        description: 'On click events button',
    },
    flexLeagues: {
        id: '2TDuxdDN',
        component: 'globalSearch',
        location: 'flexLeaguesButton',
        description: 'On click flexLeagues button',
    },
    teamTennis: {
        id: 'JMP4305y',
        component: 'globalSearch',
        location: 'teamTennisButton',
        description: 'On click teamTennis button',
    },
    adultLeague: {
        id: 'U3nEBEri',
        component: 'globalSearch',
        location: 'adultLeagueButton',
        description: 'On click adultLeague button',
    },
    adultTeamTennis: {
        id: 'LBuEcFlT',
        component: 'globalSearch',
        location: 'adultTeamTennisButton',
        description: 'On click adultTeamTennis button',
    },
    juniorTeamTennis: {
        id: 'qGi0UbTv',
        component: 'globalSearch',
        location: 'juniorTeamTennisButton',
        description: 'On click juniorTeamTennis button',
    },
    utrProTennisTour: {
        id: 'poDgqVyB',
        component: 'globalSearch',
        location: 'utrProTennisTourButton',
        description: 'On click utrProTennisTour button',
    },
    clubs: {
        id: 'n5fC1sXi',
        component: 'globalSearch',
        location: 'clubsButton',
        description: 'On click clubs button',
    },
    colleges: {
        id: 'tYlgE7uz',
        component: 'globalSearch',
        location: 'collegesButton',
        description: 'On click colleges button',
    },
    highSchools: {
        id: 'Tg4EGgkA',
        component: 'globalSearch',
        location: 'highSchoolsButton',
        description: 'On click highSchools button',
    },
    paidHits: {
        id: 'xY1OXE7r',
        component: 'globalSearch',
        location: 'paidHitsButton',
        description: 'On click paidHits button',
    },
    paidHitters: {
        id: 'rlGhyEPr',
        component: 'globalSearch',
        location: 'paidHittersButton',
        description: 'On click paidHitters button',
    },
    juniorCircuits: {
        id: 'de17wmwb',
        component: 'globalSearch',
        location: 'juniorCircuitsButton',
        description: 'On click juniorCircuits button',
    },
    collegeCircuits: {
        id: 'XAYAa6Oh',
        component: 'globalSearch',
        location: 'collegeCircuitsButton',
        description: 'On click collegeCircuits button',
    },
    juniorRegionals: {
        id: 'THXdomn9',
        component: 'globalSearch',
        location: 'juniorRegionalsButton',
        description: 'On click juniorRegionals button',
    },
    camps: {
        id: 'VYnbPHkM',
        component: 'globalSearch',
        location: 'campsButton',
        description: 'On click camps button',
    },
    pickleball: {
        id: 'XSA9KGBf',
        component: 'globalSearch',
        location: 'pickleballButton',
        description: 'On click pickleball button',
    },
    playersSeeAll: {
        id: 'T4RnpLMI',
        component: 'globalSearch',
        location: 'playersSeeAllButton',
        description: 'On click playersSeeAll button',
    },
    eventsSeeAll: {
        id: 'QMXF4LjE',
        component: 'globalSearch',
        location: 'eventsSeeAllButton',
        description: 'On click eventsSeeAll button',
    },
    collegesSeeAll: {
        id: 'agln5Qms',
        component: 'globalSearch',
        location: 'collegesSeeAllButton',
        description: 'On click collegesSeeAll button',
    },
    highSchoolsSeeAll: {
        id: 'YjFETMHC',
        component: 'globalSearch',
        location: 'highSchoolsSeeAllButton',
        description: 'On click highSchoolsSeeAll button',
    },
    clubsSeeAll: {
        id: 'zX7AlfRV',
        component: 'globalSearch',
        location: 'clubsSeeAllButton',
        description: 'On click clubsSeeAll button',
    },
    searchInput: {
        id: 'eUX6nl19',
        component: 'globalSearch',
        location: 'searchInputButton',
        description: 'On click search input bar',
    },
    searchInputContainer: {
        id: 'hUbvk6r6',
        component: 'globalSearch',
        location: 'searchInputContainer',
        description: 'search input container',
    },
    adultTeamPickleball: {
        id: 'VOgWAi4a',
        component: 'globalSearch',
        location: 'adultTeamPickleballButton',
        description: 'On click adultTeamPickleball button',
    },
    juniorTeamPickleball: {
        id: 'qj2geQZo',
        component: 'globalSearch',
        location: 'juniorTeamPickleballButton',
        description: 'On click juniorTeamPickleball button',
    },
    teamPickleball: {
        id: 'FiSh0622',
        component: 'globalSearch',
        location: 'teamPickleballButton',
        description: 'On click teamPickleball button',
    },
};

export const rightSidebarNavIDs = {
    home: {
        id: 'jxlHI4M2',
        component: 'menu',
        location: 'homeLink',
        description: 'on click home link',
    },
    collegeReport: {
        id: 'vm2ej5hL',
        component: 'menu',
        location: 'collegeReportLink',
        description: 'on click collegeReport link',
    },
    playerReport: {
        id: '5ejbAsOj',
        component: 'menu',
        location: 'playerReportLink',
        description: 'on click playerReport link',
    },
    collegeReportLegacy: {
        id: 'be8YFJrE',
        component: 'menu',
        location: 'collegeReportLink',
        description: 'on click collegeReportLegacy link',
    },
    playerReportLegacy: {
        id: 'e8LoaUnj',
        component: 'menu',
        location: 'playerReportLink',
        description: 'on click playerReportLegacy link',
    },
    players: {
        id: 'WANEYco8',
        component: 'menu',
        location: 'playersLink',
        description: 'on click players link',
    },
    organizations: {
        id: 'rSwq9wGb',
        component: 'menu',
        location: 'organizationsLink',
        description: 'on click organizations link',
    },
    college: {
        id: 'rHQVQM9V',
        component: 'menu',
        location: 'collegeLink',
        description: 'on click college link',
    },
    highSchool: {
        id: '1qnLpFdJ',
        component: 'menu',
        location: 'highSchoolLink',
        description: 'on click highSchool link',
    },
    signOut: {
        id: 'soE5hrII',
        component: 'menu',
        location: 'signOutLink',
        description: 'on click signOut link',
    },
    organizationsForCoaches: {
        id: 'MmMLg1HQ',
        component: 'menu',
        location: 'organizationsForCoachesLink',
        description: 'on click organizationsForCoaches link',
    },
    collegeForCoaches: {
        id: 'ybWW7zyO',
        component: 'menu',
        location: 'collegeForCoachesLink',
        description: 'on click collegeForCoaches link',
    },
    highSchoolForCoaches: {
        id: 'ZE9jLA9o',
        component: 'menu',
        location: 'highSchoolForCoachesLink',
        description: 'on click highSchoolForCoaches link',
    },
    signInForCoaches: {
        id: 'oRBSZRKW',
        component: 'menu',
        location: 'signInForCoachesLink',
        description: 'on click signInForCoaches link',
    },
    joinForCoaches: {
        id: 'oBP1bh6D',
        component: 'menu',
        location: 'joinForCoachesLink',
        description: 'on click joinForCoaches link',
    },
    closeBtn: {
        id: 'atJ9LDZY',
        component: 'menu',
        location: 'closeBtnLink',
        description: 'on click closeBtn link',
    },
    homeMarketing: {
        id: 's4l4ieZs',
        component: 'menu',
        location: 'homeMarketingLink',
        description: 'on click home Marketing link',
    },
    exploreMarketing: {
        id: 'jtWeYI51',
        component: 'menu',
        location: 'exploreMarketingLink',
        description: 'on click explore Marketing link',
    },
    messagesMarketing: {
        id: 'YbbJtQPE',
        component: 'menu',
        location: 'messagesMarketingLink',
        description: 'on click messages Marketing link',
    },
    profile: {
        id: 'ZxkKumQN',
        component: 'menu',
        location: 'profileLink',
        description: 'on click profile link',
    },
    settings: {
        id: '6kOsQz3d',
        component: 'menu',
        location: 'settingsLink',
        description: 'on click settings link',
    },
    subscriptions: {
        id: '6alYTI4t',
        component: 'menu',
        location: 'subscriptionsLink',
        description: 'on click subscriptions link',
    },
    eventPayments: {
        id: 'nqRHDYiq',
        component: 'menu',
        location: 'eventPaymentsLink',
        description: 'on click eventPayments link',
    },
    referral: {
        id: 'iPIdDv1K',
        component: 'menu',
        location: 'referralLink',
        description: 'on click referral link',
    },
    powerPerks: {
        id: 'ssjhqMeW',
        component: 'menu',
        location: 'powerPerksLink',
        description: 'on click powerPerks link',
    },
    collegeCoachSub: {
        id: 'vx77n3oD',
        component: 'menu',
        location: 'collegeCoachSubLink',
        description: 'on click collegeCoachSub link',
    },
    performanceHighSchool: {
        id: 'NcPZ6244',
        component: 'menu',
        location: 'performanceHighSchoolLink',
        description: 'on click performanceHighSchool link',
    },
    claimedPlayerProfile: {
        id: 'f6pK3KUv',
        component: 'menu',
        location: 'claimedPlayerProfileLink',
        description: 'on click claimedPlayerProfile link',
    },
    myClubs: {
        id: 'OGLSIoxe',
        component: 'menu',
        location: 'myClubsLink',
        description: 'on click myClubs link',
    },
    myPlayerGroup: {
        id: 'tesXRqyU',
        component: 'menu',
        location: 'myPlayerGroupLink',
        description: 'on click myPlayerGroup link',
    },
    mySavedPlayers: {
        id: 'jccRrikb',
        component: 'menu',
        location: 'mySavedPlayersLink',
        description: 'on click mySavedPlayers link',
    },
    mySavedSchools: {
        id: 'wDMWiHCi',
        component: 'menu',
        location: 'mySavedSchoolsLink',
        description: 'on click mySavedSchools link',
    },
    individualClubs: {
        id: 'IWduTqzm',
        component: 'menu',
        location: 'individualClubsLink',
        description: 'on click individualClubs link',
    },
    seeAllClubs: {
        id: 'ylorKJoj',
        component: 'menu',
        location: 'seeAllClubsLink',
        description: 'on click seeAllClubs link',
    },
    createMyPlayersGroup: {
        id: '8YHELDKV',
        component: 'menu',
        location: 'createMyPlayersGroupLink',
        description: 'on click createMyPlayersGroup link',
    },
    createAnEvent: {
        id: 'L0N6pZfE',
        component: 'menu',
        location: 'createAnEventLink',
        description: 'on click createAnEvent link',
    },
    activeLeagueTeams: {
        id: 'GFhGfPyt',
        component: 'menu',
        location: 'activeLeagueTeamsLink',
        description: 'on click activeLeagueTeams link',
    },
    seeAllLeagueTeams: {
        id: 'Ih9HFYaa',
        component: 'menu',
        location: 'seeAllLeagueTeamsLink',
        description: 'on click seeAllLeagueTeams link',
    },
    activeLeagueTeamsPickelball: {
        id: 'XqT7EgPX',
        component: 'menu',
        location: 'activeLeagueTeamsPickelballLink',
        description: 'on click activeLeagueTeamsPickelball link',
    },
    seeAllPickelballTeams: {
        id: '3fu8ZUnv',
        component: 'menu',
        location: 'seeAllPickelballTeamsLink',
        description: 'on click seeAllPickelballTeams link',
    },
    clubResources: {
        id: '1mmaE28M',
        component: 'menu',
        location: 'clubResourcesLink',
        description: 'on click clubResources link',
    },
    myPlayerGroupCreatePlay: {
        id: 'PAVjVitG',
        component: 'menu',
        location: 'myPlayerGroupCreatePlayLink',
        description: 'on click myPlayerGroupCreatePlay link',
    },
    poweredPlayersSavedList: {
        id: 'NZvrVzsb',
        component: 'menu',
        location: 'poweredPlayersSavedListLink',
        description: 'on click poweredPlayersSavedList link',
    },
    poweredSchoolsSavedList: {
        id: '38ifoQYV',
        component: 'menu',
        location: 'poweredSchoolsSavedListLink',
        description: 'on click poweredSchoolsSavedList link',
    },
    impersonate: {
        id: 'LJ7Mk6dK',
        component: 'menu',
        location: 'impersonateLink',
        description: 'on click impersonate link',
    },
    manageTemplates: {
        id: 'jXD66JOF',
        component: 'menu',
        location: 'manageTemplatesLink',
        description: 'on click manageTemplates link',
    },
    clubResourcesOrganizer: {
        id: 'oPomPZt6',
        component: 'menu',
        location: 'clubResourcesOrganizerLink',
        description: 'on click clubResourcesOrganizer link',
    },
    playersAndOrganizers: {
        id: 'oPomPZt6',
        component: 'menu',
        location: 'playersAndOrganizersLink',
        description: 'on click playersAndOrganizers link',
    },
    myAccount: {
        id: '7KgICRR0',
        component: 'menu',
        location: 'myAccountLink',
        description: 'on click myAccount link',
    },
    myAccountSettings: {
        id: 'WUBnxOLn',
        component: 'menu',
        location: 'myAccountSettingsLink',
        description: 'on click myAccountSettings link',
    },
    myAccountSubscriptions: {
        id: 'aVg4n4af',
        component: 'menu',
        location: 'myAccountSubscriptionsLink',
        description: 'on click myAccountSubscriptions link',
    },
    myAccountPayment: {
        id: 'JT2HPngG',
        component: 'menu',
        location: 'myAccountPaymentLink',
        description: 'on click myAccountPayment link',
    },
    myAccountReferral: {
        id: 'l3aXjah0',
        component: 'menu',
        location: 'myAccountReferralLink',
        description: 'on click myAccountReferral link',
    },
    utrSports: {
        id: 'DeCnAVSE',
        component: 'menu',
        location: 'utrSportsLink',
        description: 'on click utrSports link',
    },
    supportHome: {
        id: 'Jc0Huk2k',
        component: 'menu',
        location: 'supportHomeLink',
        description: 'on click supportHome link',
    },
    test: {
        id: 'pAq5h07Y',
        component: 'menu',
        location: 'testLink',
        description: 'on click test link',
    },
    educationCoaches: {
        id: 'g7NDKwqa',
        component: 'menu',
        location: 'educationCoachesLink',
        description: 'on click educationCoaches link',
    },
};

export const NewUserOnboardingIDs = {
    signInButton: {
        id: 'hSp7XmSH',
        component: 'createAccount',
        location: 'signInButton',
        description: 'on Click Sign in button',
    },
    signUpButton: {
        id: '92L8jBUf',
        component: 'createAccount',
        location: 'signUpButton',
        description: 'on Click Sign up button',
    },
    signUpEmailInput: {
        id: 'HtDMh7bx',
        component: 'createAccount',
        location: 'signUpEmailInput',
        description: 'sign up email input',
    },
    signUpPasswordInput: {
        id: 'vUYLFhL6',
        component: 'createAccount',
        location: 'signUpPasswordInput',
        description: 'sign up password input',
    },
    PIFirstNameInput: {
        id: 'pCOyFafO',
        component: 'additionalInfoForm',
        location: 'PIFirstNameInput',
        description: 'Personal information firstName input',
    },
    PILastNameInput: {
        id: '7jjmNHjm',
        component: 'additionalInfoForm',
        location: 'PILastNameInput',
        description: 'Personal information lastName input',
    },
    PILocationInput: {
        id: 'wswrNvDg',
        component: 'additionalInfoForm',
        location: 'PILocationInput',
        description: 'Personal information location input',
    },
    PIPhoneInput: {
        id: '50BaV4yZ',
        component: 'additionalInfoForm',
        location: 'PIPhoneInput',
        description: 'Personal information phone input',
    },
    PIGenderMaleInput: {
        id: 'aYoa8RqH',
        component: 'additionalInfoForm',
        location: 'PIGenderMaleInput',
        description: 'Personal information male input',
    },
    PIGenderFemaleInput: {
        id: 'iKsfl3qu',
        component: 'additionalInfoForm',
        location: 'PIGenderFemaleInput',
        description: 'Personal information female input',
    },
    PIGenderMaleV3Input: {
        id: 'zQd3U5zJ',
        component: 'additionalInfoForm',
        location: 'PIGenderMaleV3Input',
        description: 'Personal information male input',
    },
    PIGenderFemaleV3Input: {
        id: 'DwHE4CN2',
        component: 'additionalInfoForm',
        location: 'PIGenderFemaleV3Input',
        description: 'Personal information female input',
    },
    PIBirthdayMonthInput: {
        id: '5fz8H0RU',
        component: 'additionalInfoForm',
        location: 'PIBirthdayMonthInput',
        description: 'Personal information birthday month input',
    },
    PIBirthdayDayInput: {
        id: '7ZIan0SI',
        component: 'additionalInfoForm',
        location: 'PIBirthdayDayInput',
        description: 'Personal information birthday day input',
    },
    PIBirthdayYearInput: {
        id: 'iBIIygxC',
        component: 'additionalInfoForm',
        location: 'PIBirthdayYearInput',
        description: 'Personal information birthday year input',
    },
    PIWhyBirthday: {
        id: 'aQTgl7nH',
        component: 'additionalInfoForm',
        location: 'PIWhyBirthday',
        description: 'Personal information why birthday popup',
    },
    PIParent: {
        id: 'BF2N7774',
        component: 'additionalInfoForm',
        location: 'PIParent',
        description: 'Personal information parent',
    },
    PITerms: {
        id: 'bwaek1p3',
        component: 'additionalInfoForm',
        location: 'PITerms',
        description: 'Personal information terms of service',
    },
    PIPrivacy: {
        id: 'yhTFeCBF',
        component: 'additionalInfoForm',
        location: 'PIPrivacy',
        description: 'Personal information privacy policy',
    },
    PIAgree: {
        id: 'NeX6UmYs',
        component: 'additionalInfoForm',
        location: 'PIAgree',
        description: 'Personal information I agree',
    },
    PISecondaryEmail: {
        id: 'ECTB90U8',
        component: 'additionalInfoForm',
        location: 'PISecondaryEmail',
        description: 'Personal information secondary email',
    },
    PIContinueSubmit: {
        id: 'xYzArs80',
        component: 'additionalInfoForm',
        location: 'PIContinueSubmit',
        description: 'Personal information continue submit button',
    },
    PITennisId: {
        id: '6OR6wdWD',
        component: 'additionalInfoForm',
        location: 'PITennisId',
        description: 'Personal information additional field PITennisId',
    },
    TellUsMainItems: {
        id: 'Zuv3XUbB',
        component: 'TellUsAboutYourselfForm',
        location: 'TellUsMainItems',
        description: 'Tell us about yourself main items',
    },
    TellUsSubItems: {
        id: 'ckuqPD2U',
        component: 'TellUsAboutYourselfForm',
        location: 'TellUsSubItems',
        description: 'Tell us about yourself main items',
    },
    TellUsContinueButton: {
        id: 'GAJELQDm',
        component: 'TellUsAboutYourselfForm',
        location: 'TellUsContinueButton',
        description: 'Tell us about yourself continue button',
    },
    SportTypeTennis: {
        id: 'jAcUDqgw',
        component: 'SportTypeForm',
        location: 'SportTypeTennis',
        description: 'Sport type - tennis',
    },
    SportTypePickleball: {
        id: 'owTGGCax',
        component: 'SportTypeForm',
        location: 'SportTypePickleball',
        description: 'Sport type - pickleball',
    },
    SportTypeContinueButton: {
        id: 'ZkWvbP7m',
        component: 'SportTypeForm',
        location: 'SportTypeContinueButton',
        description: 'sport type continue button',
    },
    PickleballFrequencyTypes: {
        id: 'FVNZUGp2',
        component: 'PickleballSelfRatingForm',
        location: 'PickleballFrequencyTypes',
        description: 'Pickleball Self Rating Form - FrequencyTypes',
    },
    PickleballLevelTypes: {
        id: 'Px7EY5jm',
        component: 'PickleballSelfRatingForm',
        location: 'PickleballLevelTypes',
        description: 'Pickleball Self Rating Form - LevelTypes',
    },
    PickleballYesNo: {
        id: 'QBP3kahA',
        component: 'PickleballSelfRatingForm',
        location: 'PickleballYesNo',
        description: 'Pickleball Self Rating Form - Yes/No',
    },
    PickleballRating: {
        id: 'fFzTH8Dm',
        component: 'PickleballSelfRatingForm',
        location: 'PickleballRating',
        description: 'Pickleball Self Rating Form - rating',
    },
    PickleballSubmitButton: {
        id: 'c0BkPR9Q',
        component: 'PickleballSelfRatingForm',
        location: 'PickleballSubmitButton',
        description: 'Pickleball Self Rating Form - submit',
    },
    TennisFrequencyTypes: {
        id: 'N8KD3FCG',
        component: 'TennisSelfRatingForm',
        location: 'TennisFrequencyTypes',
        description: 'Tennis Self Rating Form - FrequencyTypes',
    },
    TennisMatchTypes: {
        id: 'NrTYqgKP',
        component: 'TennisSelfRatingForm',
        location: 'TennisMatchTypes',
        description: 'Tennis Self Rating Form - MatchTypes',
    },
    TennisAgeStarted: {
        id: 'VyUwKSNv',
        component: 'TennisSelfRatingForm',
        location: 'TennisAgeStarted',
        description: 'Tennis Self Rating Form - AgeStarted',
    },
    TennisSubmitButton: {
        id: 'RZesUuYJ',
        component: 'TennisSelfRatingForm',
        location: 'TennisSubmitButton',
        description: 'Tennis Self Rating Form - Submit',
    },
    DateOfBirthInfoButton: {
        id: 'dYkhHYjA',
        component: 'additionalInfoForm',
        location: 'DateOfBirthInfoButton',
        description: 'Personal information date of birth info button',
    },
    PlayerDetailsInfoButton: {
        id: 'kihYTOnm',
        component: 'additionalInfoForm',
        location: 'PlayerDetailsInfoButton',
        description: 'Personal information info button',
    },
};

// T9bNyWHB
